import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import Modal, { IModalChildProps } from '../../common/modal';

const ConfirmationModal = ({ onAccept, onClose }: IModalChildProps) => {
    const intl = useIntl();
    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({ id: 'Close' })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title">
                        <FormattedMessage id="Order_Released_Dialog_Title" />
                    </h4>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-info" onClick={onAccept}>
                        <FormattedMessage id="OK" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default ConfirmationModal;
